import {computed} from "mobx";
import {CountryViewModel} from "../../../common/country/models/country-view-model";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {OfficialDomainModel} from "./official-domain-model";

export class OfficialViewModel extends BaseViewModel {
  domainModel: OfficialDomainModel;

  @computed get country(): CountryViewModel {
    const country: CountryViewModel = this.domainModel.country && new CountryViewModel(this.domainModel.country);

    return country;
  }
}
